import React from 'react'
import {PropTypes} from 'prop-types'

import { Button } from 'react-bootstrap';
import history from '../../history';

// Bottom buttons for "save" or "cancel" a new entity persit.
export const ButtonsSaveAndCancel = (props, context) => {
    return (
        <>
            <Button variant="outline-primary mb-2 mr-1" type='submit'>{context.t('Save')}</Button>
            &nbsp;
            <Button variant="outline-secondary mb-2 mr-1" onClick={()=>{history.goBack();}}>{context.t('Cancel')}</Button>
        </>
    )
}

ButtonsSaveAndCancel.contextTypes = {
    t: PropTypes.func
}

export default ButtonsSaveAndCancel;

